import { render, staticRenderFns } from "./pageList.vue?vue&type=template&id=4b42418e"
import script from "./pageList.vue?vue&type=script&lang=js"
export * from "./pageList.vue?vue&type=script&lang=js"
import style0 from "./pageList.vue?vue&type=style&index=0&id=4b42418e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports